let clientId = "9d938ebc-b174-48cf-a9ce-0bbd5c7095d5";
let authority =
  "https://centralgroupb2c.b2clogin.com/centralgroupb2c.onmicrosoft.com/b2c_1_hrbi-etax-signin-web";
let policy_name = "b2c_1_hrbi-etax-signin-web";
let b2cDomain = "centralgroupb2c.b2clogin.com";
let tenant = "centralgroupb2c.onmicrosoft.com";

export const environment = {
  dev: false,
  uat: false,
  nonprod: false,
  production: true,
  pentest: false,

  //=========== START PROD ===================//

  version_string: "E-tax",
  apiUrl: "https://etax-apims-ext.central.co.th/prd-etax01/",
  B2C_authority: `https://${b2cDomain}/${tenant}/oauth2/v2.0/authorize?p=${policy_name}&client_id=${clientId}&nonce=defaultNonce&redirect_uri=https://etax-service.central.co.th&scope=openid&response_type=id_token&prompt=login&ui_locales=en`,
  B2C_LOGOUT: `${authority}/oauth2/v2.0/logout?post_logout_redirect_uri=https://etax-service.central.co.th&client-request-id=${clientId}&id_token_hint=`,
  //=========== END  PROD ===================//

  //=========== START DEV ===================//

  // version_string: "E-tax Invoice PENTEST Version",
  // apiUrl: "https://dev-etax-apims.central.co.th/nonprd-etax001/",
  // B2C_authority:"https://centralgroupb2cdev.b2clogin.com/centralgroupb2cdev.onmicrosoft.com/oauth2/v2.0/authorize?p=b2c_1_hrbi-etax-signin-web&client_id=28836810-d19d-41b5-b954-d8dcfc03efdc&nonce=defaultNonce&redirect_uri=https://dev-etax-service.central.co.th/&scope=openid&response_type=id_token&prompt=login&ui_locales=en",
  // B2C_LOGOUT: `https://centralgroupb2cdev.b2clogin.com/centralgroupb2cdev.onmicrosoft.com/b2c_1_hrbi-etax-signin-web/oauth2/v2.0/logout?post_logout_redirect_uri=https://dev-etax-service.central.co.th&client-request-id=28836810-d19d-41b5-b954-d8dcfc03efdc&id_token_hint=`,

  //=========== END DEV ===================//

  get_permissions:
    "https://service-api.central.co.th/slkadmin/services/v3/permissions",

  ApiLogin: "loginAuthentication",
  getABB: "getABB",
  searchcustomer: "searchCustomer",
  updateCustomer: "editCustomer",
  searchAddress: "searchAddress",
  createfulltax: "createfulltax",
  searchTaxinvoice: "searchTaxinvoice",
  replaceEditCustomer: "replaceEditCustomer",
  confirmReplace: "confirmReplace",
  confirmCreate: "confirmCreate",
  draftTransaction: "draft-transaction",

  searchCreditNote: "creditnoteSearch",
  createCreditNote: "creditnoteCreate",

  getPDF: "getPDFLink",
  getNewPDF: "get-new-url",

  taxinvoiceDetail: "taxinvoiceDetail",
  reportSearch: "reportSearch",
  inquirySearch: "inquirySearch",
  reportExport: "reportExport_2",
  resendSearch: "resendSearch",
  getCustomerLists: "getCustomerList",
  getCustomerDetail: "getCustomerDetail",
  editCustomer: "editCustomer",
  getSellerList: "getSellerList",
  getSellerDetail: "getSellerDetail",
  editSeller: "editSeller",

  getResendInvoice: "getResendInvoice",
  getNewResendInvoice: "resend-to-mail",
  inquirySearchList: "inquirySearchList",
  inquirySearchDetail: "inquirySearchDetail",
  getTaxInvoiceDetail: "get-tax-invoice-detail",

  getConfiguration: "getConfiguration",
  updateConfiguration: "updateConfiguration",
  getRoleManagement: "getRoleManagement",
  setRoleManagement: "setRoleManagement",

  getListLocation: "getListLocation?",

  externalExportExcel: "external_export_excel",
  getCnout: "getCnout",
  externalReportCSV: "external_report_csv",
  getAD2RoleManage: "getAD2RoleManage?",
  getSortPriority: "get-priority-source",

  client_id: "f67df4fac28c400abba274e7db49f09a",
  client_secret: "f50d2E0E29Ce4f559B5B388E53117923",
  getAPIVersionUrl : "https://service-api.central.co.th/prd-etax01/getVersion",
  getSystemVersionUrl : "https://service-api.central.co.th/prd-etax03/getVersion",
  // ===================== START BACKOFFICE ==========================//

  UrlBackoffice: "https://etax-apims.central.co.th/prd-etax01/",
  searchDeleteFulltax: "back-office-searchTaxDel",
  confirmDeleteFulltax: "back-office-confirmDelTax",
  searchLog: "back-office-searchLog",
  searchUnlock: "back-office-searchUnlock",
  confirmUnlock: "back-office-confirmUnlock",

  apikey: "3ef9f23b48574f85944b0d19a40f5af2",

  // ===================== END BACKOFFICE ==========================//
};
